import { Icon } from '@ui/themed';
import { useHandlers, useSite } from '../context/page-context';
import { trackUpgradeClicked } from '../lib/mixpanel';

// Replaces a setting's toggle when the store's plan doesn't include the feature.
export function PlanUpgradePrompt({
  availabilityLabel,
  changePlanLabel,
  trackingLabel,
}: {
  availabilityLabel: string;
  changePlanLabel: string;
  /** Mixpanel label, so upgrades can be attributed to the feature that prompted them. */
  trackingLabel: string;
}) {
  const site = useSite();
  const { navigationHandler } = useHandlers();

  return (
    <div className="hidden pl-6 text-right lg:block">
      <div className="-mb-0.5 flex items-center text-gray-500 text-xs">{availabilityLabel}</div>
      <button
        type="button"
        className="inline-flex cursor-pointer items-center font-medium text-indigo-600 text-xs hover:text-indigo-500"
        onClick={() => {
          trackUpgradeClicked(site, trackingLabel);
          navigationHandler.navigateById('plan');
        }}
      >
        <span>{changePlanLabel}</span>
        <Icon name="externalLink" size="sm" />
      </button>
    </div>
  );
}
